import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import Analytic from "../images/analytic.png";
import Senser from "../images/senser.png";
import NativeCloud from "../images/nativeCloud.png";
import { useTranslation } from "react-i18next";

function Mobility() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Grid
      container
      sx={{
        justifyContent: "center",
        alignItems: "center",
        gap: 5,
        background:
          "radial-gradient(39.87% 39.87% at 50% 50%, #0C3247 0%, #081525 100%)",
        pt: 3,
        pb: 5,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Orbitron",
          fontWeight: 900,
          fontSize: "28px",
          lineHeight: "52px",
          letterSpacing: "10%",
          textAlign: "center",
          verticalAlign: "middle",
          color: "#FFF",
        }}
      >
        {t("Smart Mobility in Action")}
      </Typography>

      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            m: 2,
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 4, md: 1 },
          }}
        >
          <Grid item>
            <Box
              component="img"
              src={Analytic}
              alt="Analytic"
              sx={{
                height: "auto",
                maxWidth: "75%",

                transition: "transform 0.3s ease",
                // width: {
                //   xs: "25%", // mobile

                //   md: "10%", // tablette
                // },
              }}
            />
          </Grid>
          <Grid
            item
            xs={9}
            md={5}
            gap={2}
            display="flex"
            flexDirection="column"
            sx={{
              justifyContent: "flex-start",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Orbitron",
                fontWeight: 700,
                fontSize: { xs: "18px", lg: "22px" },
                lineHeight: "30px",
                letterSpacing: "0%",
                textTransform: "uppercase",
                verticalAlign: "middle",
                background:
                  "radial-gradient(50% 875.74% at 50% 50%, #33BBA4 0%, #1F8FCE 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textAlign: "start",
              }}
            >
              {t("Analyze & Optimize")}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Roboto",
                fontWeight: 400,
                fontSize: { xs: "14px", md: "18px" },
                lineHeight: { xs: "28px", lg: "35px" },
                letterSpacing: "7%",
                textAlign: { xs: "start", lg: "justify" },

                color: " #FFFFFF",
              }}
            >
              {t("analytique text")}
            </Typography>
          </Grid>
        </Grid>
        {isMobile ? (
          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              m: 2,
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 4, md: 1 },
            }}
          >
            <Grid
              item
              xs={8}
              md={5}
              lg={4}
              xl={3}
              sx={{
                justifyContent: { xs: "center", lg: "flex-end" },
              }}
              display="flex"
            >
              <img
                src={Senser}
                alt="Senser"
                style={{
                  maxWidth: "75%",

                  height: "auto",
                  transition: "transform 0.3s ease",
                }}
              />
            </Grid>
            <Grid
              item
              xs={9}
              sm={9}
              md={5}
              gap={2}
              display="flex"
              flexDirection="column"
            >
              <Typography
                sx={{
                  fontFamily: "Orbitron",
                  fontWeight: 700,
                  fontSize: "22px",
                  lineHeight: "30px",
                  letterSpacing: "0%",
                  textTransform: "uppercase",
                  verticalAlign: "middle",

                  background:
                    "radial-gradient(50% 875.74% at 50% 50%, #33BBA4 0%, #1F8FCE 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textAlign: { xs: "start", md: "right" },
                }}
              >
                {t("Sense & Connect")}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 400,
                  fontSize: { xs: "14px", md: "18px" },
                  lineHeight: { xs: "28px", lg: "35px" },
                  letterSpacing: "7%",
                  textAlign: "justify",

                  color: " #FFFFFF",
                }}
              >
                {t("detection text")}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              m: 2,
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 4, md: 1 },
            }}
          >
            <Grid
              item
              xs={9}
              md={5}
              gap={2}
              display="flex"
              flexDirection="column"
            >
              <Typography
                sx={{
                  fontFamily: "Orbitron",
                  fontWeight: 700,
                  fontSize: "22px",
                  lineHeight: "30px",
                  letterSpacing: "0%",
                  textTransform: "uppercase",
                  verticalAlign: "middle",

                  background:
                    "radial-gradient(50% 875.74% at 50% 50%, #33BBA4 0%, #1F8FCE 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textAlign: "right",
                }}
              >
                {t("Sense & Connect")}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 400,
                  fontSize: { xs: "14px", md: "18px" },
                  lineHeight: { xs: "28px", lg: "35px" },
                  letterSpacing: "7%",
                  textAlign: "justify",

                  color: " #FFFFFF",
                }}
              >
                {t("detection text")}
              </Typography>
            </Grid>
            <Grid
              item
              xs={8}
              md={5}
              lg={4}
              xl={3}
              sx={{
                justifyContent: { xs: "center", lg: "flex-end" },
              }}
              display="flex"
            >
              <img
                src={Senser}
                alt="Senser"
                style={{
                  maxWidth: "75%",

                  height: "auto",
                  transition: "transform 0.3s ease",
                }}
              />
            </Grid>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 4, md: 1 },
          }}
        >
          <Grid item xs={8} md={5} lg={4} xl={3}>
            <img
              src={NativeCloud}
              alt="NativeCloud"
              style={{
                maxWidth: "75%",
                height: "auto",
                transition: "transform 0.3s ease",
              }}
            />
          </Grid>
          <Grid
            item
            xs={9}
            md={5}
            gap={2}
            display="flex"
            flexDirection="column"
            sx={{
              justifyContent: { xs: "center", lg: "flex-end" },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Orbitron",
                fontWeight: 700,
                fontSize: "22px",
                lineHeight: "30px",
                letterSpacing: "0%",
                textTransform: "uppercase",
                verticalAlign: "middle",
                background:
                  "radial-gradient(50% 875.74% at 50% 50%, #33BBA4 0%, #1F8FCE 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textAlign: "start",
              }}
            >
              {t("Automate & Enable")}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Roboto",
                fontWeight: 400,
                fontSize: { xs: "14px", md: "18px" },
                lineHeight: { xs: "28px", lg: "35px" },
                letterSpacing: "7%",
                textAlign: "justify",
                color: " #FFFFFF",
              }}
            >
              {t("automate text")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Mobility;
